import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../CSS/Landing.css';
import DonutAnimation from '../components/donutAnimation';
import LetterGlitch from '../components/LetterGlitch';

function Landing() {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false); // 🔹 Käytetään näkyvyyden ohjaamiseen

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, 800); // ⏱️ 2 sekunnin viive ennen elementtien näkyvyyttä

    return () => clearTimeout(timeout);
  }, []);

  const handleTransition = () => {
    navigate('/home');
  };

  return (
    <div className="landing-background position-relative vh-100">
      {/* Donut Animation Background - Hidden on mobile */}
      <div className="d-none d-md-block">
        <DonutAnimation />
      </div>
      
      {/* LetterGlitch Background - Only on mobile */}
      <div className="d-block d-md-none position-absolute w-100 h-100" style={{ zIndex: 0 }}>
        <LetterGlitch 
          glitchColors={['#eeeeee', '#dddddd', '#cccccc']}
          glitchSpeed={50}
          centerVignette={true}
          outerVignette={true}
          smooth={true}
        />
      </div>
      
      {/* Content backdrop for better readability */}
      <div className="landing-content-backdrop"></div>
      
      {/* Content Layer */}
      <div className="position-relative d-flex flex-column justify-content-center align-items-center text-white text-center h-100" style={{ zIndex: 2 }}>
        
        <h1
          className={`landing-heading px-3 px-md-5 
      ${!isVisible ? 'hidden-before-fade' : 'fade-in'}`}
        >
          Akseli<span className="d-inline d-sm-none"><br /></span> Rajahalme
        </h1>
        
        <button
          className={`btn mt-3 mt-lg-5 px-4 px-md-5 
      ${!isVisible ? 'hidden-before-fade' : 'fade-in'}`}
          onClick={handleTransition}
        >
          Siirry sivustolle
        </button>
      </div>
    </div>
  );
}

export default Landing;